import { z } from 'zod';

import { CursorPaginationMetaSchema, PaginationSchema } from '../../pagination.js';

export const CatalogUsefulLifeItemKindSchema = z.enum(['PRODUCT', 'SERVICE']);
export type CatalogUsefulLifeItemKind = z.infer<typeof CatalogUsefulLifeItemKindSchema>;

export const CatalogUsefulLifeItemTypeFilterSchema = z.enum(['ALL', 'PRODUCT', 'SERVICE']);
export type CatalogUsefulLifeItemTypeFilter = z.infer<typeof CatalogUsefulLifeItemTypeFilterSchema>;

export const CatalogUsefulLifeItemSchema = z.object({
  id: z.uuid(),
  kind: CatalogUsefulLifeItemKindSchema,
  name: z.string(),
  code: z.string().nullable(),
  categoryId: z.uuid().nullable(),
  categoryName: z.string().nullable(),
  subcategoryName: z.string().nullable(),
  usefulLifeMeters: z.number().int().nullable(),
  usefulLifeMonths: z.number().int().nullable(),
  alertMeters: z.number().int().nullable(),
  alertMonths: z.number().int().nullable(),
});
export type CatalogUsefulLifeItem = z.infer<typeof CatalogUsefulLifeItemSchema>;

export const ListCatalogUsefulLifeItemsQuerySchema = PaginationSchema.extend({
  q: z.preprocess(
    (val) => (typeof val === 'string' && val.trim() === '' ? undefined : val),
    z.string().trim().min(2).max(100).optional(),
  ),
  itemType: CatalogUsefulLifeItemTypeFilterSchema.optional().default('ALL'),
  categoryId: z.uuid().optional(),
  subcategoryId: z.uuid().optional(),
});
export type ListCatalogUsefulLifeItemsQuery = z.infer<typeof ListCatalogUsefulLifeItemsQuerySchema>;

export const ListCatalogUsefulLifeItemsResponseSchema = z.object({
  items: z.array(CatalogUsefulLifeItemSchema),
  pagination: CursorPaginationMetaSchema,
});
export type ListCatalogUsefulLifeItemsResponse = z.infer<
  typeof ListCatalogUsefulLifeItemsResponseSchema
>;

export const BulkApplyCatalogUsefulLifeTargetSchema = z.object({
  id: z.uuid(),
  kind: CatalogUsefulLifeItemKindSchema,
});

export const BulkApplyCatalogUsefulLifeBodySchema = z
  .object({
    targets: z.array(BulkApplyCatalogUsefulLifeTargetSchema).min(1).max(200),
    clearUsefulLife: z.boolean().optional(),
    usefulLifeMeters: z.number().int().optional(),
    usefulLifeMonths: z.number().int().optional(),
    alertMeters: z.number().int().optional(),
    alertMonths: z.number().int().optional(),
  })
  .superRefine((body, ctx) => {
    if (body.clearUsefulLife === true) {
      return;
    }
    const hasField =
      body.usefulLifeMeters !== undefined ||
      body.usefulLifeMonths !== undefined ||
      body.alertMeters !== undefined ||
      body.alertMonths !== undefined;
    if (!hasField) {
      ctx.addIssue({
        code: 'custom',
        message: 'At least one useful life field or clearUsefulLife is required',
        path: ['targets'],
      });
    }
  });
export type BulkApplyCatalogUsefulLifeBody = z.infer<typeof BulkApplyCatalogUsefulLifeBodySchema>;

export const BulkApplyCatalogUsefulLifeResponseSchema = z.object({
  updatedCount: z.number().int().nonnegative(),
});
export type BulkApplyCatalogUsefulLifeResponse = z.infer<
  typeof BulkApplyCatalogUsefulLifeResponseSchema
>;
